import { Component, OnInit } from '@angular/core';
import { Filter } from 'src/app/user-management/_model/filter.model';
import { GlobalService } from 'src/app/_services/global.service';
import { DataService } from 'src/app/dashboard/_services/data.service';
import { Router } from '@angular/router';
import { distinctUntilChanged, Subject, Subscription, takeUntil, tap } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { SectionsService } from '../_services/sections.service';
import { ErrorMsgService } from 'src/app/shared/error-msg/error-msg.service';
import { AmplitudeService } from 'src/app/_services/amplitude.service';
import { AutoUnsubscribe } from 'src/app/shared/decorators/auto-unsubscribe.decorator';

declare var $: any;
@AutoUnsubscribe
@Component({
  selector: 'app-sections',
  templateUrl: './sections.component.html',
  styleUrls: ['./sections.component.scss']
})
export class SectionsComponent {
  retrievedSections: any = {};
  sections = [];
  searchText: string = '';
  filterValues: Filter;
  listType: string;
  searchSubscription;
  from: number;
  to: number;
  total: number;
  nextPage: number;
  prevPage: number;
  currentPage: number = 1;
  lastPage: number;
  loading: boolean;
  firstLoad = true;
  noResultsFlag: boolean = false;
  currLang;
  tableControls: any = { data: [] };
  showDeleteModalFlag = false;
  selectedSectionId: number;
  destroy$ = new Subject<void>(); 
  constructor(
    private globalService: GlobalService,
    private dataService: DataService,
    private translate: TranslateService,
    private router: Router,
    private sectionService: SectionsService,
    private errorMsgService: ErrorMsgService,
    private amplitudesService: AmplitudeService) {
    this.globalService.getLang().pipe(takeUntil(this.destroy$)).subscribe(lng => {
      //console.log('(c)sections_(f)getLang_(L)51' , lng);
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
    this.searchSubscription = new Subscription();
  }

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
    this.errorMsgService.setMessage(null);
  }

  ngOnInit(): void {
    this.listType = window.location.pathname.split('/')[2];
    // to remove the black screen and the stuck error msg popup if error message was just closed in sibling component 
    $('.modal').modal('hide');
    $('body').removeClass('modal-open');
    $('.modal-backdrop').remove();
    this.globalService.getLang().pipe(takeUntil(this.destroy$)).subscribe(lng => {
      //console.log('(c)sections_(f)getLang_(L)70' , lng);
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
    this.globalService.startLoading();

    this.globalService.getLoading().pipe(takeUntil(this.destroy$)).subscribe(res => {
      //console.log('(c)sections_(f)getLoading_(L)77' , res);
      this.loading = res;
    })

    this.firstLoad = true;

    this.showList();
    let x = this.dataService.getSearchText().subscribe(res => {
      if (res !== null) {
        this.firstLoad = false;
        this.searchText = res;
        this.currentPage = 1;
        this.showList();
      }
    })
    this.searchSubscription.add(x);
  }

  showList() {
    this.globalService.startLoading();
    this.sectionService.getAllSections(25, this.currentPage, this.searchText).pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      //console.log('(c)sections_(f)getAllSections_(L)98' , res);
      this.sections = res['data'].map(element => (
        {
          name: element.name,
          id: element.id,
          no_of_grades: element?.grades?.length,
          truncate_hover: { string: this.getConcatenatedNames(element?.grades), array: element?.grades, hover_flag: false },
          grades: element?.grades,
          students_count: element?.students_count,
        }
      ))
      this.from = res?.from;
      this.to = res?.to;
      this.total = res?.total;
      this.lastPage = res?.last_page;
      this.translate.get('init').pipe(takeUntil(this.destroy$)).subscribe(res => {
        //console.log('(c)sections_(f)translateInit_(L)113' , res);
        this.setTableData();
      });
      // this.translate.onLangChange.subscribe(res => {
      //   this.setTableData();
      // });
      this.translate.onLangChange.pipe(
        distinctUntilChanged((prev, curr) => prev.lang === curr.lang), // Only trigger if the language changes
        tap((res) => {
          //console.log('(c)sections_(f)translateOnChange_(L)123' , res);
          this.setTableData();
        }),
        takeUntil(this.destroy$) // Automatically unsubscribe when destroy$ emits
      )
      .subscribe();
      this.globalService.stopLoading();
    },err =>{
      this.globalService.stopLoading();
      this.errorMsgService.setMessage(err?.error?.message);
    })
  }


  setTableData() {
    this.tableControls = {
      selection: false,
      paging: true,
      view: 'compact',
      title:'table-view.titles.sections',
      totalTitle:'table-view.total-titles.sections',
      pagination: {
        from: this.from,
        to: this.to,
        total: this.total
      },
      columns: [
        {
          name: this.translate.instant('school-management.sections.table.name'),
          sort: false,
          type: "string",
          source: "name"
        },
        {
          name: this.translate.instant('school-management.sections.table.num-grades'),
          sort: false,
          type: "string",
          source: "no_of_grades"
        },
        {
          name: this.translate.instant('school-management.sections.table.names-grades'),
          sort: false,
          type: "truncate_hover",
          source: "truncate_hover"
        },
        {
          name: this.translate.instant('school-management.sections.table.students-count'),
          sort: false,
          type: "string",
          source: "students_count"
        },
        {
          name: this.translate.instant('school-management.sections.table.actions'),
          type: "action-btns",
        },
      ],
      data: this.sections
    }
  }

  tableEventHandeler(event) {
    event?.e?.stopPropagation();

    switch (event?.action) {
      case "editBtnClicked":
        this.setSectionData(event?.target?.data);
        break;
      case "deleteBtnClicked":
        this.selectedSectionId = event?.target?.data?.id;
        this.showDeleteModal();
        break;
      case "pagination":
        this.paginationHandling(event.target);
        break;
    }
  }

  getConcatenatedNames(arr): string {
    return arr?.length > 0 ? arr.map(item => item.name).join(this.currLang == 'ar' ? '،' : ',') : '';
  }

  setSectionData(data: any) {
    // using local storage instead of observable to prevent bug on reload as observable resets
    // this.sectionService.setSectionData(data);
    localStorage.setItem('sectionEditData', JSON.stringify(data));
    setTimeout(() => {
      this.router.navigate([`school-management/sections/edit/${data?.id}`]);
    }, 100);
  }
  addSection() {
    this.router.navigate([`school-management/sections/add/new`]);
    this.amplitudesService.trackEvent('CTA.Add_New_Section',{});
  }

  deleteSection() {
    this.sectionService.deleteSection(this.selectedSectionId).pipe(takeUntil(this.destroy$)).subscribe(res => {
      //console.log('(c)sections_(f)deleteSection_(L)204' , res);
      this.closeDeleteModal();
      this.currentPage = 1;
      this.showList();
    },err=>{
      this.closeDeleteModal();
      this.errorMsgService.setMessage(err?.error?.message);
    })
  }

  paginationHandling(event) {
    this.currentPage += event.dir;
    this.showList();
  }

  showDeleteModal() {
    this.showDeleteModalFlag = true;
  }
  closeDeleteModal() {
    this.showDeleteModalFlag = false;
  }

  
}
